import { render, staticRenderFns } from "./ExamUserInfo.vue?vue&type=template&id=fac6ff36&scoped=true&lang=html&"
import script from "./ExamUserInfo.vue?vue&type=script&lang=js&"
export * from "./ExamUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./ExamUserInfo.vue?vue&type=style&index=0&id=fac6ff36&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac6ff36",
  null
  
)

export default component.exports